import React from "react";
import styled from "styled-components";

type AnnotationComponentProps = {
  children: React.ReactNode;
  level: "default" | "warning" | "error";
  mt?: string;
  mb?: string;
};

const AnnotationStyle = styled.div<{
  $level?: string;
  $mt?: string;
  $mb?: string;
}>`
  border-radius: 4px;
  margin-top: ${(props) => props.$mt || "0"};
  margin-bottom: ${(props) => props.$mb || "0"};
  padding: 10px 5px;
  ${(props) => {
    switch (props.$level) {
      case "default":
        return `
          background:rgb(247 247 247);
          border: 1px solid rgb(212 212 212);
          color: rgb(64 64 64);
      `;
      case "warning":
        return `
          background: rgb(255 253 197);
          border: 1px solid rgb(255 232 48);
          color: rgb(255 170 0);
      `;
      case "error":
        return `
          background: #f8d7da;
          border: 1px solid #f5c2c7;
          color: #842029;
      `;
    }
  }}
`;

const Annotation: React.FC<AnnotationComponentProps> = ({
  children,
  level,
  mt,
  mb,
}) => {
  return (
    <AnnotationStyle $level={level} $mt={mt} $mb={mb}>
      {children}
    </AnnotationStyle>
  );
};

export default Annotation;
